{
  "valid": "Действительный"
}
